import React, { useMemo, useState, useEffect } from "react";
import "./portfolio.less";
import { Reit, PropertyDetails } from "../../../../types/reit.types";
import { safeFormat, toNumber } from "../../../../utils/financialHelper";

interface PortfolioProps {
  reit: Reit | null;
}

const Portfolio: React.FC<PortfolioProps> = ({ reit }) => {
  const [place, setPlace] = useState<string>("");

  // get unique locations from DB
  const places = useMemo(() => {
    if (!reit?.realEstateLocData) return [];
    const uniquePlaces = Array.from(
      new Set(
        reit.realEstateLocData
          .map((p) => p.location?.value)
          .filter((loc): loc is string => !!loc)
      )
    );
    return uniquePlaces;
  }, [reit]);

  // set default place
  useEffect(() => {
    if (places.length && !place) {
      setPlace(places[0]);
    }
  }, [places, place]);

  // filter portfolio data by selected location & skip header = "H"
  const portfolioData = useMemo(() => {
    if (!reit?.realEstateLocData || !place) return [];
    return reit.realEstateLocData.filter(
      (p) => p.location?.value === place && p.header?.value !== "H"
    );
  }, [reit, place]);

  return (
    <section className="portfolio">
      <div className="portfolio__card">
        {/* Header */}
        <div className="portfolio__header">
          <h2>Portfolio Details</h2>

          {/* Dropdown */}
          <div className="portfolio__dropdown">
            <div className="custom-select">
              <select value={place} onChange={(e) => setPlace(e.target.value)}>
                {places.map((loc, idx) => (
                  <option key={idx} value={loc}>
                    {loc}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="portfolio__table">
          <table>
            <thead>
              <tr>
                <th>Properties</th>
                <th>Completed Area (msf)</th>
                <th>Under Construction/ Future Area (msf)</th>
                <th>Leasable Area (msf)</th>
                <th>Occupancy</th>
                <th>Market Value (₹ Cr.)</th>
              </tr>
            </thead>
            <tbody>
              {portfolioData.map((prop: PropertyDetails, idx: number) => (
                <tr key={idx}>
                  <td>{safeFormat(prop.placeName?.value)}</td>
                  <td>{safeFormat(prop.completedAreaMsf?.value)}</td>
                  <td>{safeFormat(prop.developmentAreaMsf?.value)}</td>
                  <td>{safeFormat(prop.leasableAreaMsf?.value)}</td>
                  <td>
                    {prop.occupancyRate?.value != null
                      ? `${toNumber(prop.occupancyRate.value).toFixed(2)}%`
                      : "-"}
                  </td>
                  <td>{safeFormat(prop.marketValueInMnRs?.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
